// Copyright (c) Move Closer 2022.

import { Methods, ResourcesRegistry } from '@movecloser/front-core'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const resources: ResourcesRegistry = {
  shared: {
    connection: 'api',
    prefix: 'core',
    methods: {
      search: {
        url: 'search',
        method: Methods.Get
      }
    }
  },

  synerise: {
    connection: 'api',
    prefix: 'synerise',
    methods: {
      syneriseSearch: {
        url: 'search',
        method: Methods.Get
      }
    }
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const trustedShopResources: ResourcesRegistry = {
  trustedShop: {
    connection: 'api',
    prefix: 'etrusted',
    methods: {
      reviews: {
        url: 'reviews',
        method: Methods.Get
      },
      reviewsCount: {
        url: 'reviews/count',
        method: Methods.Get
      }
    }
  }
}
